import React from "react";
import PropTypes from "prop-types";

import TextInputWithError from "../../../../inputs/TextInputWithError";
import CheckboxWithError from "../../../../inputs/CheckboxWithError";
import submittalInputs from "../../../../inputs/inputConfigs/submittals";

import { DescriptionSection, OverrideSection } from "./components";

const {
  InputComponent: _InputComponent,
  ...descriptionInput
} = submittalInputs.submittalDescription;

const asText = value => value || "";

export const hasDescriptionChanges = (
  { receivedDescription, approvedDescription },
  specRequirement
) =>
  asText(receivedDescription) !==
    asText(specRequirement?.receivedDescription) ||
  asText(approvedDescription) !== asText(specRequirement?.approvedDescription);

const SubmittalDescriptions = ({
  receivedDescription,
  approvedDescription,
  onReceivedDescriptionChange,
  onApprovedDescriptionChange,
  showOverride,
  overrideContent,
  onOverrideContentChange,
  disabled,
  divider,
}) => (
  <DescriptionSection divider={divider}>
    <TextInputWithError
      {...descriptionInput}
      name="receivedDescription"
      label="Received"
      value={receivedDescription}
      onChange={({ target: { value } }) =>
        onReceivedDescriptionChange(asText(value))
      }
      disabled={disabled}
      avoidDebounce
      ignoreCaption
      ignoreLabeledText
      resize="vertical"
    />
    <TextInputWithError
      {...descriptionInput}
      name="approvedDescription"
      label="Approved"
      value={approvedDescription}
      onChange={({ target: { value } }) =>
        onApprovedDescriptionChange(asText(value))
      }
      disabled={disabled}
      avoidDebounce
      ignoreCaption
      ignoreLabeledText
      resize="vertical"
    />
    {showOverride && (
      <OverrideSection>
        <CheckboxWithError
          name="overrideContent"
          label="Override Existing Content"
          value={overrideContent}
          onChange={({ target: { value } }) => onOverrideContentChange(value)}
          disabled={disabled}
          ignoreLabeledText
        />
      </OverrideSection>
    )}
  </DescriptionSection>
);

SubmittalDescriptions.defaultProps = {
  divider: true,
};

SubmittalDescriptions.propTypes = {
  receivedDescription: PropTypes.string,
  approvedDescription: PropTypes.string,
  onReceivedDescriptionChange: PropTypes.func.isRequired,
  onApprovedDescriptionChange: PropTypes.func.isRequired,
  showOverride: PropTypes.bool,
  overrideContent: PropTypes.bool,
  onOverrideContentChange: PropTypes.func,
  disabled: PropTypes.bool,
  divider: PropTypes.bool,
};

export default SubmittalDescriptions;
